// extracted by mini-css-extract-plugin
export var bulkPurchaseTable = "_g-0";